















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ToggleInput from '@/components/ToggleInput.vue'
import Typography from '@/components/Rain/Typography/Typography.vue'

@Component<BaseFeatureToggle>({
    components: { ToggleInput, Typography }
})
export default class BaseFeatureToggle extends Vue {
    @Prop({ type: String, required: true, default: '' })
    public readonly label!: string
    @Prop({ type: String, required: true, default: '' })
    public readonly toggleId!: string
    @Prop({ type: Boolean, required: true, default: false })
    public readonly checked!: boolean
    @Prop({ type: String, required: false, default: '' })
    public readonly tooltip!: string

    public handleChange(newValue: boolean) {
        this.$emit('change', newValue, this.toggleId)
    }
}
